import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import {
  boolean,
  doublePrecision,
  integer,
  pgTable,
  text,
  timestamp,
  uuid,
} from 'drizzle-orm/pg-core';

export const operationalCosts = pgTable('operational_costs', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  label: text('label'),
  minQuantity: integer('min_quantity').notNull(),
  // null = faixa aberta no topo (sem limite máximo de camisetas).
  maxQuantity: integer('max_quantity'),
  price: doublePrecision('price').notNull(),
  isActive: boolean('is_active').default(true),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
});

export type OperationalCost = InferSelectModel<typeof operationalCosts>;
export type CreateOperationalCostInput = InferInsertModel<typeof operationalCosts>;
export type UpdateOperationalCostInput = Partial<CreateOperationalCostInput>;
